import { HoldingUserPermissions, UserPermissions } from "../../../../shared/permissions/types";
import { ApiInvite, ApiUser } from "./api";
import { useHoldingPermissionsEditor } from "./components/hooks";
import { FeaturePermissionsTemplate, FeaturesPermissionsType } from "./templates/templates";

export type { HoldingUserPermissions, UserPermissions }
export type Invite = ApiInvite

export interface NewInvite {
    email: string
    accessLevel: InitialAccessLevel
}

export const enum InitialAccessLevel {
    Full = 1,
    Agronomist = 2,
    Operator = 3,
}

export interface User extends Omit<ApiUser, "holdingPermissions" | "userPermissions" | "croppingPermissions"> {

    displayName: string

    userPermissions: UserPermissions
    holdingPermissions: FeaturePermissionsIndex
    croppingPermissions: CroppingPermissions

}

export interface EditorUser extends User {

    updated: boolean
    deleted: boolean

    restrictCroppingAccess: boolean

    initialState: {

        holdingRole: HoldingRole
        holdingPermissions: FeaturePermissionsIndex

        restrictCroppingAccess: boolean
        croppingPermissions: CroppingPermissions

    }

}

export type FeaturePermissionsIndex = { [key: string]: FeaturePermissions }


export interface FeaturePermissions {

    key: string
    app: string
    feature: string

    type: FeaturesPermissionsType
    template: FeaturePermissionsTemplate<{}>
    defaultValues: {}

    availability: {
        owner: boolean
        member: boolean
    },

    values: {}
    initialValues: {}
    updated: boolean

}

export const enum HoldingRole {
    Member = 1,
    Owner = 2,
    RestrictedMember = 3
}


export interface GenericProps extends ReturnType<typeof useHoldingPermissionsEditor> {
}


export interface UserUpdate {

    userId: number
    email: string
    delete: boolean
    holdingRole: HoldingRole

    holdingPermissions: HoldingUserPermissions
    croppingPermissions: CroppingPermission[]
}


export interface Cropping {

    croppingId: number

    description: string

    fieldId: number
    fieldName: string
    fieldGroup: string

    area: number

    cropId: number
    cropName: string

    varietyName: string

    cropDescription: string
}

export interface CroppingPermission {
    croppingId: number
    authorized: boolean
}

export type CroppingPermissions = Record<number, CroppingPermission>